import { Component, OnInit, ViewChild } from '@angular/core'
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
  selector: 'app-confirm-revert',
  templateUrl: './confirm-revert.component.html',
  styleUrls: ['./confirm-revert.component.scss']
})
export class ConfirmRevertComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent

  color = 'primary'
  icon = 'info circle'
  message = ''

  constructor() { }

  ngOnInit() {}

  show () {
    return this.dialogRef.show()
  }
}
